import {airBlue} from '@modifi/colors'
import {media} from '@modifi/ui'
import styled from 'styled-components'

export const DummySpan = styled.div`
  &:empty,
  :last-child {
    display: none;
  }
`

const imageSizes = {
  portrait: {
    height: 260,
    width: 200,
  },
  box: {
    height: 234,
    width: 234,
  },
}

type CardWrapperProps = {
  cardType: string
}

export const CardWrapper = styled.div<CardWrapperProps>`
  display: flex;
  flex-direction: column;
  text-align: center;
  width: ${({cardType}): number =>
    cardType === 'portrait' ? imageSizes.portrait.width : imageSizes.box.width}px;

  img {
    height: ${({cardType}): number =>
      cardType === 'potrait' ? imageSizes.portrait.height : imageSizes.box.height}px;
  }

  span {
    width: 100%;
    text-align: center;
  }

  margin: ${({cardType}): string => (cardType === 'portrait' ? '0 8px' : '0 16px')};
`

export const Headline = styled.h4`
  margin: 0;
  margin-top: 16px;
`

export const SeparatorWrapper = styled.div`
  align-items: center;
  justify-content: center;
  height: 92px;
  margin: 32px 0;
  width: 300px;
  display: flex;
  ${media.md`
    width: 110px;
    margin: 0;
    height: ${({cardType}: {cardType: string}): number =>
      cardType === 'potrait' ? imageSizes.portrait.height : imageSizes.box.height}px;
  `}
`

export const Separator = styled.div`
  align-self: center;
  width: 6px;
  height: 110px;
  margin: 16px 0;
  ${media.md`
    margin: 0;
    width: 100%;
    height: 6px;
  `}
  border-radius: 16px;
  background-color: ${airBlue};
`
